import { render, staticRenderFns } from "./ResponsibleItem.vue?vue&type=template&id=54d75774&scoped=true&"
import script from "./ResponsibleItem.vue?vue&type=script&lang=js&"
export * from "./ResponsibleItem.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleItem.vue?vue&type=style&index=0&id=54d75774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d75774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VIcon,VTooltip})
